function formatFile(file) {
	return {
		url: file.url,
		id: file._id,
		format: file.format,
		name: file.name
	};
}

function isEmpty(obj) {
	for (var prop in obj) {
		if (obj.hasOwnProperty(prop)) {
			return false;
		}
	}

	return JSON.stringify(obj) === JSON.stringify({});
}

function findFiles(obj, data, parent) {
	return Object.keys(obj).reduce(function (acc, key) {
		var currentKey = parent ? parent + "." + key : key;
		var current = obj[key] || {};
		var currentData = data[key] || {};

		if (current.inputType === "signature" && currentData && (!isEmpty(currentData) || currentData.constructor === File))
			return parseFile(acc, currentKey, currentData, current);
		else if (current.inputType === "file" && currentData  && (!isEmpty(currentData) || currentData.constructor === File))
			return parseFile(acc, currentKey, currentData, current);
		else if (current.type === "array" && current.inputType === "fileList")
			return parseFileList(acc, currentKey, currentData, current);
		else if (current.type === "object")
			return parseObject(acc, currentKey, currentData, current);
		else if (current.type === "array")
			return parseArray(acc, currentKey, currentData, current);
		else
			return acc;
	}, []);
}

function createFileKey(currentKey, currentData) {
	var update = {};
	update.key = currentKey;
	update.data = currentData;
	return update;
}

function parseFile(arr, currentKey, currentData) {
	if (currentData.id) return arr; // File is already uploaded
	return arr.concat(createFileKey(currentKey, currentData));
}

function parseFileList(arr, currentKey, currentData) {
	if (!currentData || !currentData.length) return arr;
	return arr.concat(currentData.reduce(function (acc, data, index) {
		var key = currentKey + "." + index + "";
		if (data.id) return acc; // File is already uploaded
		return acc.concat(createFileKey(key, data.file));
	}, []));
}

function parseObject(arr, currentKey, currentData, current) {
	var properties = current.properties || {};
	return arr.concat(findFiles(properties, currentData, currentKey));
}

function parseArray(arr, currentKey, currentData, current) {
	var items = current.items || {};
	if (items.inputType === "file")
		return parseFile(arr, currentKey, currentData, current);
	else return arr.concat(findFiles(items, currentData, currentKey));
}

export {
	formatFile,
	findFiles,
	createFileKey,
	parseArray,
	parseFile,
	parseFileList,
	parseObject,
};